import type { FileSaveOptions, FileSaveResult, FileLoadResult } from './types'

export class WebFileService {
  async save(content: any, options: FileSaveOptions = {}): Promise<FileSaveResult> {
    // Web版：使用浏览器下载
    const blob = new Blob([JSON.stringify(content, null, 2)], {
      type: 'application/json'
    })

    const url = URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = options.defaultName || 'canvas.json'
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    URL.revokeObjectURL(url)

    return {
      success: true,
      platform: 'web',
      method: 'download'
    }
  }

  async load(): Promise<FileLoadResult> {
    // Web版：通过input元素选择文件
    return new Promise((resolve, reject) => {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = '.json,.canvas'

      input.onchange = (e) => {
        const file = (e.target as HTMLInputElement).files?.[0]
        if (!file) {
          reject(new Error('No file selected'))
          return
        }

        const reader = new FileReader()

        reader.onload = (event) => {
          try {
            const content = JSON.parse(event.target?.result as string)
            resolve({
              content,
              name: file.name
            })
          } catch (error) {
            reject(new Error('Failed to parse file'))
          }
        }

        reader.onerror = () => {
          reject(new Error('Failed to read file'))
        }

        reader.readAsText(file)
      }

      input.oncancel = () => {
        reject(new Error('File selection cancelled'))
      }

      input.click()
    })
  }
}

export class WebNotificationService {
  async show(title: string, body: string): Promise<void> {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(title, { body })
    } else if ('Notification' in window && Notification.permission !== 'denied') {
      // 请求权限
      const permission = await Notification.requestPermission()
      if (permission === 'granted') {
        new Notification(title, { body })
      }
    }
  }
}



